import { useCallback, useContext } from 'react'
import { WebSocketContext } from '../Providers/WebSocket/WebSocketContext'

export default function useStatusEvento () {
    const { sendWs } = useContext(WebSocketContext)

    const mudarStatusEvento = useCallback((id, status) => {
        sendWs('mudarStatusEvento', { id, status })
    }, [])

    return {
        mudarStatusEvento
    }
}
